import React, { PureComponent } from 'react'
import classname from 'classnames'
import { FormattedMessage, injectIntl } from 'react-intl'
import TimeAgo from 'react-timeago'
import englishStrings from 'react-timeago/lib/language-strings/en'
import frenchStrings from 'react-timeago/lib/language-strings/fr'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import withToast from 'src/components/Toast'
import { Flex } from '@chakra-ui/react'
import { Form, Field } from 'react-final-form'
import chatService from 'src/utils/ChatService'
import { logError } from 'src/utils/helpers'
import { validateEmail } from 'src/utils/validation'
import styles from '../styles.module.less'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../../../translations'

class EmailMessageType extends PureComponent {
  state = {
    emailSubmitting: false,
  }

  validateEmailForm = values => {
    const { intl } = this.props
    const errors = {}
    if (!values.email) {
      errors.email = intl.formatMessage(intlMessages.emailRequired)
    }
    if (values.email && !validateEmail(values.email)) {
      errors.email = intl.formatMessage(intlMessages.emailValid)
    }
    return errors
  }

  submitEmail = values => {
    const { intl, channel, setChatEmail, toast } = this.props

    const email = values.email.toLowerCase()

    this.setState(
      {
        emailSubmitting: true,
      },
      () => {
        // TODO: replace this with new API
        // message.updateBody(JSON.stringify([{ type: 'email', text: values.email }]))
        chatService
          .updateChannel(email, channel.uniqueName)
          .then(() => {
            setChatEmail(email)
          })
          .catch(() => {
            toast({
              title: intl.formatMessage(intlMessagesApp.appErrorTitle),
              description: intl.formatMessage(intlMessages.emailSubmittionError),
              status: 'error',
            })

            setChatEmail(null)
          })
          .finally(() => {
            this.setState({
              emailSubmitting: false,
            })

            // Force re-render since this is a PureComponent
            this.forceUpdate()
          })
      },
    )
  }

  getChatEmail = () => {
    const { chatEmail, channel } = this.props
    try {
      if (channel.state.friendlyName.length > 0) {
        return channel.state.friendlyName
      }
    } catch (e) {
      return chatEmail
    }

    return chatEmail
  }

  render() {
    const { emailSubmitting } = this.state
    const { intl, message, channel, renderAuthor } = this.props

    if (!(channel && channel.uniqueName)) {
      logError('Chat channel not found')
      return ''
    }

    const formatter =
      intl && intl.locale === 'fr' ? buildFormatter(frenchStrings) : buildFormatter(englishStrings)

    const chatEmail = this.getChatEmail()

    return (
      <div className={styles.email} data-qa='chat__message__content'>
        {!chatEmail ? (
          <div className={classname(styles.messageItem, { messageItemColor: false })}>
            <p>
              <FormattedMessage
                id='app.chat.message.getNotifiedByEmail'
                defaultMessage='Get notified by email'
              />
            </p>
            <Form
              className={styles.emailItem}
              onSubmit={this.submitEmail}
              validate={this.validateEmailForm}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Flex mt={'10px'}>
                    <Field
                      name='email'
                      render={({ input, meta }) => (
                        <Input
                          error={meta}
                          name='email'
                          placeholder='email@domain.com'
                          type='text'
                          {...input}
                        />
                      )}
                    />
                    <Button type='submit' isLoading={emailSubmitting} ml={'5px'}>
                      <FormattedMessage id='app.chat.submit' defaultMessage='Send' />
                    </Button>
                  </Flex>
                </form>
              )}
            />
          </div>
        ) : (
          <div className={classname(styles.messageItem, { messageItemColor: false })}>
            <p>
              <FormattedMessage
                id='app.chat.message.notifiedMessage'
                defaultMessage="You'll be notified here and by email"
              />
            </p>
            <div className={styles.emailSubmitted}>{chatEmail}</div>
          </div>
        )}
        <div className={styles.status} data-qa='chat__message__status chat__message__status--time'>
          {renderAuthor}
          <TimeAgo date={message.timestamp} formatter={formatter} />
        </div>
      </div>
    )
  }
}

export default injectIntl(withToast(EmailMessageType))
